import React from 'react';
import { IS_STAGING } from '../config/appInfo';

function StageRibbon({ compact = false, className = '' }) {
  if (!IS_STAGING) {
    return null;
  }

  const svgClassName = compact
    ? 'pointer-events-none absolute bottom-0 left-0 z-10 h-16 w-20'
    : 'pointer-events-none absolute bottom-0 left-0 z-10 h-20 w-[7.5rem]';

  return (
    <svg
      aria-label="Ambiente de staging"
      className={`${svgClassName} ${className}`}
      viewBox="0 0 144 96"
      role="img"
    >
      <polygon
        points="0,0 46,0 132,86 86,86"
        fill="#fbbf24"
      >
        <title>STAGING</title>
      </polygon>
      <text
        x="66"
        y="39"
        transform="rotate(45 66 39)"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="#0f172a"
        fontSize={compact ? '10' : '11'}
        fontWeight="900"
        letterSpacing={compact ? '2.6' : '3.2'}
      >
        STAGING
      </text>
    </svg>
  );
}

export default StageRibbon;
